





































































































































import { CrsForm } from '@resclick/crs-ui';
import { IWidget } from '@resclick/data-access';
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import TabGeneral from './property-widgets-modal-tabs/general.tab.vue';
import TabThemeEditor from './property-widgets-modal-tabs/theme-editor.tab.vue';
import TabInjections from './property-widgets-modal-tabs/injections-shell.tab.vue';

import { copyToClipboard } from 'quasar';

import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css';

import { highlight, languages } from 'prismjs';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-markup';
import 'prismjs/themes/prism-tomorrow.css';

@Component({
  components: {
    PrismEditor,
    TabGeneral,
    TabThemeEditor,
    TabInjections,
  },
})
export default class PropertyWidgetsModal extends Vue {
  @PropSync('open') openSync!: boolean;
  @PropSync('id', { type: String }) idSync!: string;
  @Prop() propertyId!: boolean;
  form!: CrsForm<'properties', 'createWidget' | 'updateWidget'>;
  currentTab = 'general';
  embedCodeDialog = false;

  get embedCode() {
    const widgetURL = 'https://widget.resclick.com/rc-widget.min.js';
    const script = `<script type="module" defer src="${widgetURL}"></` + 'script>';
    // @ts-ignore
    const code = `${script}
<!-- Booking Widget -->
<rc-widget token="${this.idSync}"></rc-widget>`;

    return code;
  }

  get mode() {
    return this.idSync ? 'update' : 'create';
  }

  copyToClipboard(text: string) {
    return copyToClipboard(text);
  }

  highlighter(code: any) {
    return highlight(code, languages.html, 'html'); // languages.<insert language> to return html with markup
  }

  onTabChange(tabName: string) {
    const tab: any = this.$refs[this.currentTab];
    if (tab?.checkUnsaved) tab.checkUnsaved(() => (this.currentTab = tabName));
    else this.currentTab = tabName;
  }

  onUpdateGeneral(data: IWidget) {
    if (data.id) this.idSync = data.id;
  }

  onHide(value: boolean) {
    if (!value) {
      const tab: any = this.$refs[this.currentTab];
      if (tab?.checkUnsaved) {
        tab.checkUnsaved(() => {
          this.currentTab = 'general';
          this.openSync = false;
        });
      } else {
        this.currentTab = 'general';
        this.openSync = false;
      }
    } else this.openSync = true;
  }
}
